import { DatepickerTranslations } from '../models/interfaces'

export const DATEPICKER = {
    minDate: { year: 1900, month: 1, day: 1 },
    maxDate: { year: new Date().getFullYear() + 10, month: new Date().getMonth() + 1, day: new Date().getDate() }
}

export const PAGINATION = {
    defaultNumberOfRowsOnPage: 25,
    defaultSort: 'id,asc',
    firstPageIndex: 0,
    maxNumberOfPagesToDisplay: 5,
    possibleNumberOfRowsOnPage: [5, 10, 25, 50, 100]
}

export const SVG_ICON_NAMES = [
    'Accept',
    'Account',
    'ArrowTop',
    'ArrowBottom',
    'ArrowLeft',
    'ArrowRight',
    'ArrowTopSmall',
    'ArrowBottomSmall',
    'ArrowLeftSmall',
    'ArrowRightSmall',
    'Bank',
    'Bell',
    'Box',
    'Calendar',
    'Cancel',
    'Carton',
    'Change',
    'ChevronTop',
    'ChevronBottom',
    'ChevronLeft',
    'ChevronRight',
    'ChevronTopDouble',
    'ChevronBottomDouble',
    'ChevronLeftDouble',
    'ChevronRightDouble',
    'Close',
    'Credit',
    'CreditAdd',
    'CreditCancel',
    'CreditCard',
    'CreditCardTransfer',
    'Currencies',
    'Deposit',
    'Desktop',
    'Document',
    'Edit',
    'FileDownload',
    'FileUpload',
    'Filters',
    'Firma',
    'Home',
    'Logout',
    'Mail',
    'Menu',
    'Minus',
    'Order',
    'OrderAdd',
    'OrderCancel',
    'Plus',
    'Procent',
    'Question',
    'Refresh',
    'Search',
    'Settings',
    'SortBottom',
    'SortDefault',
    'SortTop',
    'Star',
    'Time',
    'TimeWarning',
    'Timer',
    'User',
    'UserAdd',
    'UserCancel',
    'Vat',
    'World'
] as const

export const I18N_DATEPICKER_VALUES: DatepickerTranslations = {
    EN: {
        weekdays: ['mon', 'tue', 'wen', 'thu', 'fri', 'sat', 'sun'],
        months: ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec']
    },
    PL: {
        weekdays: ['pon', 'wto', 'śro', 'czw', 'pią', 'sob', 'nie'],
        months: ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru']
    }
}
